module.exports = __webpack_public_path__ + "img/background_line.83753cf5.svg";